export class StateDefinition {
    defaultValue;

    localStorage = false;

    constructor(defaultValue, localStorage) {
        this.localStorage = localStorage;
        this.defaultValue = defaultValue;
    }
}
